<template>
  <p
    class="pagination-text"
    data-sb-regression="sb-pagination-text"
  >
    <!--
      @slot Slot to show the pagination text
    -->
    <slot />
  </p>
</template>

<script>

export default {
  name: 'SbPaginationText',
};
</script>

<style lang="scss">
@import '@src/components/Pagination/style/sb-pagination-text.scss';
</style>
